<template>
	<div v-if="step === 0">
		<h4 class="title">{{ $t('account_register.title1') }}</h4>
		<div class="text_box">
			<p>{{ $t('account_register.text1') }}</p>
			<p>{{ $t('account_register.text2') }}</p>
			<p>{{ $t('account_register.text3') }}</p>
			<p>{{ $t('account_register.text4') }}</p>
		</div>
		<h4 class="title">{{ $t('account_register.title2') }}</h4>
		<div class="text_box">
			<p>{{ $t('account_register.text5') }}</p>
			<p>{{ $t('account_register.text6') }}</p>
		</div>
		<p class="caution">{{ $t('account_register.text7') }}</p>
		<div :class="['button_area_bottom']">
			<button class="" @click="$emit('closeRegist')">
				{{ $t('button.cancel') }}
			</button>
			<button class="btn_next" @click="stepNext">
				{{ $t('button.next') }}
			</button>
		</div>
	</div>
	<div v-if="step === 1" class="regist">
		<h4 class="title">
			{{
				$t('account_register.title3', {
					title: assetInfo.title,
				})
			}}
		</h4>
		<div class="text_box">
			<p>
				{{ $t('account_register.text8') }}<br />
				{{
					$t('account_register.text9', {
						title: assetInfo.title,
					})
				}}<br />
				{{ $t('account_register.text10') }}<br />
				{{ $t('account_register.text11') }}<br />
				{{ $t('account_register.text12') }}<br /><br />

				{{
					$t('account_register.text13', {
						title: assetInfo.title,
					})
				}}
			</p>
		</div>
		<div class="box_check">
			<label class="checkbox_container">
				{{ $t('account_register.agree') }}
				<input type="checkbox" v-model="checked" />
				<span class="checkmark"></span>
			</label>
		</div>

		<div :class="['button_area_bottom']">
			<button class="" @click="stepBack">
				{{ $t('button.back') }}
			</button>
			<button class="btn_next" @click="stepNext">
				{{ $t('button.new_account') }}
			</button>
		</div>
	</div>
	<div v-if="step === 2" class="add_account">
		<div class="add_account_inner">
			<p class="">{{ $t('account_register.title4') }}</p>
			<input
				type="text"
				:placeholder="this.$t('account_register.text15')"
				readonly
			/>
			<p class="">{{ $t('account_register.title5') }}</p>
			<input
				type="text"
				:placeholder="this.$t('account_register.text15')"
				readonly
			/>
			<p class="">{{ $t('account_register.title6') }}</p>
			<input
				type="text"
				v-model="title"
				:placeholder="this.$t('account_register.text14')"
			/>
			<p class="">{{ $t('account_register.title7') }}</p>
			<input
				type="text"
				:placeholder="this.$t('account_register.text15')"
				readonly
			/>
			<p class="">{{ $t('account_register.title8') }}</p>
			<input
				type="text"
				:placeholder="this.$t('account_register.text15')"
				readonly
			/>
			<p class="">{{ $t('account_register.title9') }}</p>
			<input type="text" :placeholder="assetInfo.code" readonly />
		</div>
		<div :class="['button_area_bottom']">
			<button class="" @click="stepBack">
				{{ $t('button.back') }}
			</button>
			<button class="btn_next" @click="createAccount">
				{{ $t('button.open_account') }}
			</button>
		</div>
	</div>
	<div v-if="step === 3" class="created_account">
		<div class="created_account_inner">
			<h4 class="title">{{ $t('account_register.title10') }}</h4>
			<div class="mb_20">
				<p class="mb_10">{{ $t('account_register.text16') }}</p>
				<input
					type="text"
					:placeholder="create_account_info?.account_number"
					readonly
				/>
			</div>
		</div>
		<div :class="['button_area_bottom d_flex justify_center']">
			<button class="btn_next" @click="$emit('closeRegist', accountSeq)">
				{{ $t('button.confirm') }}
			</button>
		</div>
	</div>
	<ModalMessage v-if="messageModal" @closeModal="messageModal = false">
		<div :class="'status_icon ' + modalIcon"></div>
		<p class="status_text">{{ modalStatusMessage }}</p>
		<div class="button_area">
			<button class="" @click="messageModal = false">
				{{ $t('rtr_auth-register.confirm') }}
			</button>
		</div>
	</ModalMessage>
</template>

<script>
import { isMobile } from '@/common/mobile';
import ModalMessage from '@/components/Layout/ModalMessage';
import { createAccount } from '@/api/account';
import { commonError } from '@/common/dialog';
import { createAddress } from '@/api/address';
import { mapGetters } from 'vuex';

export default {
	name: 'AccountRegister',
	components: {
		ModalMessage,
	},
	props: {
		assetInfo: {
			type: Object,
		},
	},
	emits: ['closeRegist'],
	data() {
		return {
			step: 0,
			checked: false,
			messageModal: false,
			modalIcon: 'error',
			modalStatusMessage: this.$t('modal.message.need_agree'),
			title: '',
			accountSeq: null,
			accountAddressInfo: {},
			isMobile: isMobile(),
		};
	},
	computed: {
		...mapGetters('account', ['accounts']),
		create_account_info() {
			return this.accounts.find(item => {
				return item.seq === this.accountSeq;
			});
		},
	},
	methods: {
		stepBack() {
			this.step--;
		},
		stepNext() {
			if (this.step === 1 && !this.checked) {
				this.messageModal = true;
				return;
			}
			this.step++;
			if (isMobile()) {
				const modalPosition = document.querySelector('.modal_scrollable');
				modalPosition.scrollTo(0, 0);
			}
		},
		async createAccount() {
			const params = {
				asset_seq: this.assetInfo.seq,
				title: this.title,
				is_master: 'Y',
			};
			await createAccount(params)
				.then(data => {
					this.accountSeq = data.seq;
				})
				.then(() => {
					this.$store.dispatch('account/getAccounts');
				})
				.then(() => {
					if (this.assetInfo.plugin_seq === 0) {
						this.stepNext();
						return;
					}
					this.createAccountAddress();
				})
				.then(() => {
					this.$store.dispatch('account/getAccounts');
				})
				.catch(commonError);
		},
		async createAccountAddress() {
			await createAddress({ account_seq: this.accountSeq })
				.then(() => {
					// this.loadAccountAddress(data.seq);
					this.stepNext();
				})
				.catch(commonError);
		},
		// async loadAccountAddress(addressSeq) {
		// 	await fetchAddress(addressSeq)
		// 		.then(data => {
		// 			this.accountAddressInfo = data;
		// 			this.stepNext();
		// 		})
		// 		.catch(commonError);
		// },
	},
};
</script>
